'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Created by hustcc on 18/6/9.
 * Contract: i@hust.cc
 */

var SizeSensorId = exports.SizeSensorId = 'size-sensor-id';

var SensorStyle = exports.SensorStyle = 'display:block;position:absolute;top:0;left:0;height:100%;width:100%;overflow:hidden;pointer-events:none;z-index:-1;opacity:0';

var SensorClassName = exports.SensorClassName = 'size-sensor-object';


//////////////////
// WEBPACK FOOTER
// ../~/size-sensor/lib/constant.js
// module id = ZHfx
// module chunks = 0